import React, { useRef, useState } from 'react';
import './Receipts.scss';
import { DataGrid, LoadPanel, Menu, Popup } from 'devextreme-react';
import { Item } from 'devextreme-react/cjs/context-menu';
import { Column } from 'devextreme-react/cjs/data-grid';
import GlobalParams from '../../helpers/GlobalParams';
import notify from 'devextreme/ui/notify';
import ApiPostHelper from '../../helpers/ApiPostHelper';
import ReportView from '../ReportView/ReportView';


function NewMember({ onClosePopup }) {

  const [ReceiptData,SetReceiptData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rptUrl, setRptUrl] = useState('');

  const containerRef = useRef(null);
  const renderPdfViewer = (base64PDF) => {
    const container = containerRef.current;

    if (container) {
      const viewerObject = document.createElement('object');
      viewerObject.type = 'application/pdf';
      viewerObject.style.width = '100%';
      viewerObject.style.height = '800px';
      viewerObject.data = 'data:application/pdf;base64,' + base64PDF;

      container.appendChild(viewerObject);
    }
  };


  //////report popup//////////
  const fetchRpt = async (url) => {
    try {

      const result = await ApiPostHelper.postData(
        GlobalParams.LoginApiUrlPrefix + 'getReportsLaravel',
        GlobalParams.bearerToken,
        JSON.stringify({
          url_path: url,
        })
      );

      if (!result.success) {
        setIsLoading(false);
        setPopupReportVisible(false);
        notify("Report Error", 'error', 5000);
      }

      setPopupReportVisible(true);
      // Delay setting isLoading to false until after renderPdfViewer completes
      renderPdfViewer(result.data);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      notify("Error Fetching the report", 'error', 5000);
    } finally {
      // Set isLoading to false after renderPdfViewer completes
      setIsLoading(false);
    }
  };
  const [popupReportVisible, setPopupReportVisible] = React.useState(false);
  const [report_name, setreport_name] = React.useState('');
  const hideReportButtonClick = () => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }
    setPopupReportVisible(false);
  };
  //////end of report popup///

  const onMenuReceiptItemClick = (cellInfo, item) => {
    if (item === 'Receipt') {
      setIsLoading(true);
      let url =
        GlobalParams.RptUrlPrefix +
        'reportType=021&referenceNumber=' + cellInfo.data.reference + '&email=' +
        GlobalParams.UserEmail;

      setRptUrl(url);
      fetchRpt(url);
    }
  };

  const menuReceiptItems = [
    { text: 'Receipt', icon: 'doc' }
  ];
  const actionReceiptsColumnTemplate = (cellInfo) => {
    return (
      <div>
        <Menu
          onItemClick={(e) => onMenuReceiptItemClick(cellInfo, e.itemData.text)}
        >
          <Item
            text=" "
            items={menuReceiptItems}
          >
          </Item>
        </Menu>
      </div>
    );
  };


  return (
    <div style={{
      paddingTop: '10px',
    }}>
      <LoadPanel visible={isLoading} />
      <div>
        <Popup style={{
          padding: 20,
        }}
          visible={popupReportVisible}
          title={report_name}
          dragEnabled={true}
          showCloseButton={true}
          hideOnOutsideClick={false}
          onHiding={hideReportButtonClick}
        >
          <ReportView
            url={rptUrl}
            onClosePopup={hideReportButtonClick}
          />
        </Popup>
      </div>
      <div>
        <div>
          {
            <DataGrid
              dataSource={ReceiptData}
              searchPanel={
                {
                  visible: true,
                  width: 250
                }
              }
              wordWrapEnabled={true}
            // onRowClick={(e) => {
            //   setIsLoading(true);
            //   let url =
            //     GlobalParams.RptUrlPrefix +
            //     'reportType=002&referenceNumber=' + e.data.reference + '&email=' +
            //     GlobalParams.UserEmail;

            //   setRptUrl(url);

            //   fetchRpt(url);
            // }}
            >
              <Column width={50} caption="" cellRender={actionReceiptsColumnTemplate} />
              <Column dataField="schemeNo" visible={false}></Column>
              <Column dataField="reference"></Column>
              <Column dataField="isEndorsement" dataType='boolean' visible={false}></Column>
              <Column dataField="endorse_no" visible={false}></Column>
              <Column dataField="EndorsementNarration" caption='Narration'></Column>
              <Column dataField="trans_date" dataType='date'></Column>
              <Column dataField="gross_amount" cellRender={(cellInfo) => {
                const formattedAmount = parseFloat(cellInfo.data.gross_amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                return (
                  <span>{formattedAmount}</span>
                );
              }}>
              </Column>
            </DataGrid>
          }
        </div>
      </div>
    </div>
  );
}

export default NewMember;
